import { render, staticRenderFns } from "./sharedroute.vue?vue&type=template&id=69c5e61c&scoped=true&"
import script from "./sharedroute.vue?vue&type=script&lang=js&"
export * from "./sharedroute.vue?vue&type=script&lang=js&"
import style0 from "./sharedroute.vue?vue&type=style&index=0&id=69c5e61c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c5e61c",
  null
  
)

export default component.exports